import React from 'react';

const Blog = () => {
  return (
    <div className="min-h-screen pt-24 pb-12">
      <div className="container mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="heading-hero mb-4">Free Study Materials</h1>
          <p className="body-large text-[var(--text-secondary)] max-w-2xl mx-auto">
            Access free educational resources prepared by our faculty.
          </p>
        </div>

        {/* Study Resources */}
        <div className="bg-[var(--bg-card)] rounded-2xl p-8 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

            <div className="text-center p-6 bg-[var(--accent-purple-200)] rounded-xl">
              <h3 className="heading-3 mb-2">Sample Papers</h3>
              <p className="body-small text-[var(--text-secondary)] mb-4">
                Previous year question papers for all classes
              </p>
              <button className="text-sm font-medium hover:underline">
                Download Now
              </button>
            </div>

            <div className="text-center p-6 bg-[var(--accent-blue-200)] rounded-xl">
              <h3 className="heading-3 mb-2">Study Notes</h3>
              <p className="body-small text-[var(--text-secondary)] mb-4">
                Chapter-wise notes and summaries
              </p>
              <button className="text-sm font-medium hover:underline">
                Access Notes
              </button>
            </div>

            <div className="text-center p-6 bg-[var(--accent-orange-200)] rounded-xl">
              <h3 className="heading-3 mb-2">Video Lectures</h3>
              <p className="body-small text-[var(--text-secondary)] mb-4">
                Free video lessons on key topics
              </p>
              <button className="text-sm font-medium hover:underline">
                Watch Videos
              </button>
            </div>

            <div className="text-center p-6 bg-[var(--accent-green-200)] rounded-xl">
              <h3 className="heading-3 mb-2">Practice Tests</h3>
              <p className="body-small text-[var(--text-secondary)] mb-4">
                Online mock tests and quizzes
              </p>
              <button className="text-sm font-medium hover:underline">
                Start Practice
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Blog;
